import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { TopBar } from "@/components/TopBar";
import { HomePage } from "@/pages/HomePage";
import { ClansIndex, ClanDetailPage } from "@/pages/Clans";
import { PersonDetailPage } from "@/pages/PersonDetail";
import { TreePage } from "@/pages/TreePage";
import { ActivityPage } from "@/pages/ActivityPage";
import { RegistryPage } from "@/pages/RegistryPage";
import { HistoryPage } from "@/pages/HistoryPage";
import { MembersOnly } from "@/components/MembersOnly";
import { AccountPage, ForgotPasswordPage, ResetPasswordPage } from "@/pages/AccountPage";
import { AdminPage } from "@/pages/AdminPage";
import { ChiefsPage } from "@/pages/ChiefsPage";
import { PrintableClanPage } from "@/pages/PrintableClanPage";
import { LoginPage, RegisterPage } from "@/pages/Auth";
import { PublicPersonPage } from "@/pages/PublicPersonPage";
import { useAuth } from "@/context/AuthContext";

function PersonRoute() {
  const { user } = useAuth();
  if (user === null || user === undefined) return null;
  const member = user && (user.validated || user.is_super_admin);
  return member ? <PersonDetailPage /> : <PublicPersonPage />;
}

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-[#F7F3EE]">
      <TopBar />
      {children}
      <footer className="border-t border-[#E3D5CA] py-10 mt-20">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="font-serif-heritage text-[#6B4226] text-lg">Ekom 1 · Nkolafamba · Cameroun</div>
          <div className="label-uppercase text-[#6E5B4F]">Mémoire Evondo — préservée par la communauté</div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors theme="light" />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPasswordPage />} />
            <Route path="/reinitialiser-mot-de-passe" element={<ResetPasswordPage />} />
            <Route path="/print/clans/:key" element={<PrintableClanPage />} />
            <Route path="*" element={
              <Shell>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/clans" element={<ClansIndex />} />
                  <Route path="/clans/:key" element={<ClanDetailPage />} />
                  <Route path="/tree" element={<MembersOnly><TreePage /></MembersOnly>} />
                  <Route path="/chefs" element={<ChiefsPage />} />
                  <Route path="/persons/:id" element={<PersonRoute />} />
                  <Route path="/activity" element={<MembersOnly officers><ActivityPage /></MembersOnly>} />
                  <Route path="/registre" element={<MembersOnly><RegistryPage /></MembersOnly>} />
                  <Route path="/histoire" element={<HistoryPage />} />
                  <Route path="/mon-compte" element={<AccountPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                </Routes>
              </Shell>
            } />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
